module.exports = __webpack_public_path__ + "static/media/11_Greg.8df794bb.png";